import { t } from 'i18next';
import { Flex } from 'reflexbox';
import styled from 'styled-components';

import { Goal } from '@treams/treams-network';
import { Expand, Heading, Skeleton, tokens } from '@treams/treams-ui';

import { SubgoalsContext } from '../../goals/subgoals/Subgoals';
import GoalDescription from './GoalDescription';

const SubgoalsContent = styled.div`
	padding-left: 40px;
`;

const Subgoals = styled.div`
	border-top: 1px solid #e0e0e0;
	margin: 0;
	padding: 15px;
`;

const StyledGoalContent = styled.div`
	box-sizing: border-box;

	// Expand can't handle margins so we need to add whitespace as a border
	border-top: 5px solid white;
	background-color: ${tokens.surface.secondary};
`;

export default Skeleton(
	function GoalContent({ goal, collapsed }: { goal: Goal; collapsed: boolean }) {
		return (
			<Expand expanded={!collapsed}>
				<StyledGoalContent>
					<GoalDescription competencyGoal={goal.competency!} />
					<Subgoals>
						<Heading mb={3}>
							<Flex alignItems="center">{t('developmentPlan.index.goalChecklistTitle')}</Flex>
						</Heading>
						<SubgoalsContent>
							<SubgoalsContext goal={goal as Goal} editable={true} />
						</SubgoalsContent>
					</Subgoals>
				</StyledGoalContent>
			</Expand>
		);
	},
	function GoalContentSkeleton() {
		return <Skeleton.Box height={200} mt={1} />;
	},
);
